/*=============================================
=            Table Row Cell Styling           =
=============================================*/

@import './pk-table-cell.variables';

:host {
  @apply flex;
}

:host(.pk-table--row-cell) {
  @apply box-border w-full items-center overflow-hidden text-ellipsis whitespace-nowrap px-[--pk-cell--horizontal-pad] py-[--pk-cell--vertical-pad] text-[length:--pk-cell--font-size];

  justify-content: var(--pk-cell--justify-content);
  text-align: var(--pk-cell--text-align);

  &.is-active {
    @apply font-bold tracking-[-0.25px] text-text-01 #{!important};
  }

  &.highlight {
    @apply font-semibold text-primary-01;
  }

  &.with-divider {
    @apply border-0 border-r-[1px] border-solid border-ui-02;
  }

  &.with-width {
    @apply shrink-0 grow-0 basis-[--pk-cell--width,_auto];
  }

  &.can-grow {
    @apply grow;
  }

  &.can-shrink {
    @apply shrink;
  }

  &.is-hidden {
    @apply hidden;
  }

  &::slotted(*) {
    @apply overflow-hidden text-ellipsis whitespace-nowrap;
  }
}

.row-index {
  @apply mr-m inline-flex self-center;
}
